import { Link } from "react-router-dom";
import { siteInfo, siteStats, trendingList } from "@/mocks/news";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20warm%20vermillion%20red%20and%20amber%20gold%20paper%20fragments%20floating%20over%20a%20deep%20charcoal%20background%2C%20soft%20dramatic%20side%20lighting%2C%20film%20grain%20texture%2C%20modern%20magazine%20cover%20aesthetic%2C%20moody%20cinematic%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=liao-hero-main&orientation=landscape"
          alt="料闻社独家黑料速递主视觉背景"
          title="料闻社 · 独家黑料速递"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/85 to-foreground-950/40" />
        <div className="absolute inset-0 grain-overlay opacity-60" />
      </div>

      <div className="relative mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-[1.35fr_1fr] lg:gap-14 lg:py-24">
        <div className="flex w-full flex-col justify-center">
          <span className="inline-flex w-fit items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3.5 py-1.5 text-xs text-accent-200">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-2 w-2 animate-pulse-dot rounded-full bg-accent-400" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
            </span>
            独家速递进行中 · 今日新料实时更新
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-[1.18] text-background-50 md:text-5xl lg:text-[3.4rem]">
            独家黑料速递
            <span className="mt-2 block text-primary-400">把散落的传闻排成一条时间线</span>
          </h1>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
            覆盖最新事件与人物动态，每条资讯标注依据类型：官方口径、可核对记录、还是暂缺依据的线索。
            追踪独家黑料快报，获取不被删的完整时间线梳理，吃瓜看真相一步到位。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/#feed"
              className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-flashlight-line" />
              查看今日速递
            </Link>
            <Link
              to="/#subscribe"
              className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/30 px-7 text-sm font-semibold text-background-100 transition-colors hover:bg-background-100/10"
            >
              <i className="ri-mail-add-line" />
              订阅每日清单
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-100/15 pt-7 lg:grid-cols-4">
            {siteStats.map((stat) => (
              <div key={stat.label}>
                <dt className="text-xs text-background-300/80">{stat.label}</dt>
                <dd className="mt-1 flex items-baseline gap-1">
                  <span className="label-font text-2xl font-semibold text-accent-400 md:text-3xl">
                    {stat.value}
                  </span>
                  <span className="text-xs text-background-300/80">{stat.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <aside className="w-full">
          <div className="rounded-lg border border-background-100/15 bg-background-950/50 p-5 backdrop-blur-sm md:p-6">
            <div className="flex items-center justify-between gap-3 border-b border-background-100/15 pb-3.5">
              <h2 className="flex items-center gap-2 font-heading text-base font-bold text-background-50">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-fire-fill text-primary-400" />
                </span>
                今日热榜
              </h2>
              <span className="text-xs text-background-300/70">实时排序</span>
            </div>
            <ol className="mt-1">
              {trendingList.slice(0, 6).map((item) => (
                <li key={item.rank}>
                  <Link
                    to={`/article/${item.articleId}`}
                    className="group flex items-start gap-3 border-b border-background-100/10 py-3 last:border-b-0"
                  >
                    <span
                      className={`label-font mt-0.5 w-6 shrink-0 text-sm font-semibold ${
                        item.rank <= 3 ? "text-primary-400" : "text-background-400"
                      }`}
                    >
                      {String(item.rank).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm leading-snug text-background-100 transition-colors group-hover:text-accent-300">
                        {item.title}
                      </span>
                      <span className="mt-1 inline-block rounded-md bg-background-100/10 px-2 py-0.5 text-[11px] text-background-300">
                        {item.tag}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
            <Link
              to="/category/all"
              className="mt-4 flex h-10 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-100/20 text-xs font-medium text-background-100 transition-colors hover:bg-background-100/10"
            >
              查看全部速递条目
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <p className="mt-3 text-center text-[11px] text-background-400">
            {siteInfo.updateNote} · 榜单每 30 分钟重排一次
          </p>
        </aside>
      </div>
    </section>
  );
}